/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import ReferralCodeControllerDtoReferralCodeGenerateRequest from '../model/ReferralCodeControllerDtoReferralCodeGenerateRequest';
import ReferralCodeControllerDtoReferralCodeGenerateResponse from '../model/ReferralCodeControllerDtoReferralCodeGenerateResponse';

/**
* ReferralCode service.
* @module api/ReferralCodeApi
* @version 1.0
*/
export default class ReferralCodeApi {

    /**
    * Constructs a new ReferralCodeApi. 
    * @alias module:api/ReferralCodeApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiReferralCodeReferralCodeGeneratePost operation.
     * @callback module:api/ReferralCodeApi~apiReferralCodeReferralCodeGeneratePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ReferralCodeControllerDtoReferralCodeGenerateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ReferralCodeControllerDtoReferralCodeGenerateRequest} [referralCodeControllerDtoReferralCodeGenerateRequest] 
     * @param {module:api/ReferralCodeApi~apiReferralCodeReferralCodeGeneratePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ReferralCodeControllerDtoReferralCodeGenerateResponse}
     */
    apiReferralCodeReferralCodeGeneratePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['referralCodeControllerDtoReferralCodeGenerateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ReferralCodeControllerDtoReferralCodeGenerateResponse;
      return this.apiClient.callApi(
        '/api/ReferralCode/ReferralCodeGenerate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
